import PersonIcon from '@mui/icons-material/Person';
import { Grid, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserQuery } from '@/api/queries/useAuth';
import { Hint } from '@/components/Hint/Hint';
import { ImageAvatar } from '@/components/ImageAvatar/ImageAvatar';
import { NotificationsButton } from '@/components/NotificationsButton/NotificationsButton';
import { HINTS, paths, STORAGE } from '@/constants';
import { assetCategory, hintsBlock } from '@/enums';
import { useColorMode } from '@/hooks';
import { usePrefValue } from '@/preferences';
import { HeaderText, NameProfileText } from './NavigationProfile.styles';

export const NavigationProfile = () => {
    const { t } = useTranslation();
    const side_bar = usePrefValue('side_bar');
    const { data: user } = useUserQuery();
    const isDarkMode = useColorMode();
    const theme = useTheme();

    return (
        <Grid
            container
            sx={[
                {
                    borderTop: theme => `1px solid ${theme.custom.c7}`,
                    paddingTop: '16px',
                    background: theme => theme.palette.background.paper,
                    // zIndex: '50000',
                    paddingBottom: '16px',
                    [theme.breakpoints.down('lg')]: {
                        paddingTop: '8px',
                    },
                },
                !side_bar && {
                    width: '40px',
                    [theme.breakpoints.down('lg')]: {
                        width: '36px',
                        paddingBottom: '8px',
                    },
                },
            ]}
        >
            <Hint
                block={hintsBlock.menu}
                hint={HINTS[hintsBlock.menu].profile}
                mode="menu"
                anchorSx={[!side_bar && { alignItems: 'flex-start' }]}
            >
                {side_bar ? (
                    <div className="flex w-full flex-row items-center flex-nowrap gap-[16px]">
                        <Grid
                            container
                            sx={[
                                {
                                    flexDirection: 'row',
                                    gap: '16px',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                    padding: '3px 0 3px 2px',
                                    borderRadius: '8px',
                                    minHeight: '48px',
                                },
                                location.pathname === paths.profile.index && {
                                    background: theme => theme.custom.c7,
                                },
                            ]}
                        >
                            <ImageAvatar
                                width="32px"
                                height="32px"
                                src={
                                    user && user.assets.length > 0 && user.assets.some(item => item.category === assetCategory.image)
                                        ? STORAGE + (user.assets.find(item => item.category === assetCategory.image)?.path ?? '')
                                        : ''
                                }
                                alt={user ? `${user.first_name} ${user.last_name}` : ' '}
                                title={user ? `${user.first_name} ${user.last_name}` : 'profile'}
                                margin="0"
                                children={
                                    <PersonIcon
                                        sx={{
                                            color: theme => (isDarkMode ? 'inherit' : theme.custom.c22),
                                            fontSize: '1.25rem',
                                        }}
                                    />
                                }
                            />
                            <div className="gap-[8px] w-full">
                                <HeaderText children={t('profile.profile')} />
                                <NameProfileText
                                    children={user ? `${user.first_name} ${user.last_name}` : ' '}
                                    variant="body2"
                                    sx={[
                                        !isDarkMode && { color: theme => theme.custom.c22 },
                                        location.pathname === paths.profile.index && {
                                            color: theme => theme.palette.secondary.main,
                                        },
                                    ]}
                                />
                            </div>
                        </Grid>
                        <NotificationsButton />
                    </div>
                ) : (
                    <Grid
                        container
                        gap="16px"
                        justifyContent="center"
                        minHeight="48px"
                        sx={{
                            [theme.breakpoints.down('lg')]: {
                                gap: '8px',
                            },
                        }}
                    >
                        <ImageAvatar
                            width="32px"
                            height="32px"
                            backgroundColor={location.pathname === paths.profile.index ? theme.palette.text.secondary : theme.custom.c5}
                            src={
                                user && user.assets.length > 0 && user.assets.some(item => item.category === assetCategory.image)
                                    ? STORAGE + (user.assets.find(item => item.category === assetCategory.image)?.path ?? '')
                                    : ''
                            }
                            alt={user ? `${user.first_name} ${user.last_name}` : ' '}
                            title={user ? `${user.first_name} ${user.last_name}` : 'profile'}
                            margin="0"
                            sx={{
                                opacity: location.pathname === paths.profile.index ? 1 : 0.6,
                                marginTop: '1px',
                            }}
                            children={
                                <PersonIcon
                                    sx={{
                                        color: theme => (isDarkMode ? 'inherit' : theme.custom.c22),
                                        fontSize: '1.25rem',
                                    }}
                                />
                            }
                        />
                        <NotificationsButton />
                    </Grid>
                )}
            </Hint>
        </Grid>
    );
};
